// src/components/SortSelect.js
import React from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

const SortSelect = ({ currentSort }) => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const params = new URLSearchParams(search);

    const handleChange = (e) => {
        const selectedSort = e.target.value;

        if (selectedSort) {
            params.set('sort', selectedSort);
        } else {
            params.delete('sort');
        }

        // Reset page number if present in URL path (e.g. /page/2)
        // This logic depends on how your router handles pagination.
        // If pagination is part of the path, you might need to redirect to page 1.
        // If pagination is a query param, reset it here.
        // Assuming pagination is handled via path params in most screens, 
        // but if it were a query param:
        // params.set('page', 1); 

        // If the current path contains /page/X, we should probably strip it to go back to page 1
        let newPathname = pathname;
        if (pathname.includes('/page/')) {
            newPathname = pathname.split('/page/')[0];
        }

        navigate(`${newPathname}?${params.toString()}`);
    };

    return (
        <div className="d-flex justify-content-end w-100">
            <Form.Select
                value={currentSort || ''}
                onChange={handleChange}
                className="form-select border-0 shadow-sm bg-light rounded-pill px-3 py-2"
                style={{ width: '100%', cursor: 'pointer', fontSize: '0.9rem' }}
                aria-label="Ordenar productos"
            >
                <option value="">Ordenar por...</option>
                <option value="newest">Más nuevos</option>
                <option value="price_asc">Precio: Menor a Mayor</option>
                <option value="price_desc">Precio: Mayor a Menor</option>
                <option value="name_asc">Nombre: A-Z</option>
                <option value="name_desc">Nombre: Z-A</option>
            </Form.Select>
        </div>
    );
};

export default SortSelect;
